import { ca } from '@cian/analytics';

export function trackQuickLinksView(level: number) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: `view_alsoLooking_${level}`,
    label: '',
  });
}

export function trackQuickLinkClick(level: number, url: string, label: string) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: `click_alsoLooking_${level}`,
    label: url,
  });

  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_fast_link',
    label,
    page: {
      extra: {
        query_string: url.split('?')[1] || '',
      },
    },
    useLastProducts: true,
  });
}
